import {Action} from '@ngrx/store';
import {BpmnNodeCreatedResult} from '@ispm-client/modules/bpmn-modeler/models/bpmn-node-created-result';
import {NodeCreationResult} from '@ispm-client/modules/bpmn-modeler/models/node-creation-result';
import {TreatmentPlanSelectorResult} from '@ispm-client/modules/bpmn-modeler/models/treatment-plan-selector-result';

export enum NodeActionTypes {
  NODES_INIT = '[node action] nodes init',
  NODE_CREATED = '[node action] node created',
  NODE_UPDATED = '[node action] node updated',
  NODE_DELETED = '[node action] node deleted',
  NODE_COPY_TO_CLIPBOARD = '[node action] node copied',
  NODE_CLIPBOARD_RESET = '[node action] reset clipboard',
  NODE_OPEN_NOTES = '[node] open notes',
  ROOT_NODE_NAME_UPDATED = '[node action] root node name updated',
  CLEAR_NODE_SELECTION = '[node selection] clear node selection',
  UPDATE_TREATMENT_NODES_PROPERTIES = '[nodes update] update treatment nodes properties'
}

export class NodesInit implements Action {
  readonly type = NodeActionTypes.NODES_INIT;

  constructor(public payload: Map<string, BpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult>>) {
  }
}

export class NodeCreated implements Action {
  readonly type = NodeActionTypes.NODE_CREATED;

  constructor(public payload: BpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult>) {
  }
}

export class NodeUpdated implements Action {
  readonly type = NodeActionTypes.NODE_UPDATED;

  constructor(public payload: BpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult>) {
  }
}

export class NodeDeleted implements Action {
  readonly type = NodeActionTypes.NODE_DELETED;

  constructor(public payload: { nodeId: string }) {
  }
}

export class NodeCopied implements Action {
  readonly type = NodeActionTypes.NODE_COPY_TO_CLIPBOARD;

  constructor(public payload: { clipboard: any }) {
  }
}

export class NodesClipboardReset implements Action {
  readonly type = NodeActionTypes.NODE_CLIPBOARD_RESET;

  constructor(public payload: {}) {
  }
}

export class NodeOpenNotes implements Action {
  readonly type = NodeActionTypes.NODE_OPEN_NOTES;

  constructor(public payload: { node: any }) {
  }
}

export class RootNodeUpdatedName implements Action {
  readonly type = NodeActionTypes.ROOT_NODE_NAME_UPDATED;

  constructor(public payload: {}) {
  }
}

export class ClearNodeSelection implements Action {
  readonly type = NodeActionTypes.CLEAR_NODE_SELECTION;

  constructor(public payload: {}) {
  }
}

export class UpdateTreatmentNodesProperties implements Action {
  readonly type = NodeActionTypes.UPDATE_TREATMENT_NODES_PROPERTIES;

  constructor(public payload: { nodes: string[], data: any }) {
  }
}

export type NodesAction =
  NodesInit
  | NodeCreated
  | NodeUpdated
  | NodeDeleted
  | NodeCopied
  | NodesClipboardReset
  | RootNodeUpdatedName
  | ClearNodeSelection
  | UpdateTreatmentNodesProperties;
